import { Injectable } from '@angular/core';
import {getAndDecryptFromSessionStorage, setToSessionStorageEncryptedValue} from 'dbp-channels-business-toolboxify';
import jwtDecode, { JwtPayload } from 'jwt-decode';

@Injectable({
  providedIn: 'root'
})
export class CryptoStorageService {
  public setToSessionStorage: (key: string, value: any) => undefined;
  public getFromSessionStorage: (key: string) => any;

  constructor() {
    this.setToSessionStorage = setToSessionStorageEncryptedValue;
    this.getFromSessionStorage = getAndDecryptFromSessionStorage;
  }



  // добавляем на случай отсутствия номера телефона при входе через ak kamal
  // и автоматический выбор компании
  addJWTInfoForAkKamalClients(token): void {
    let profileInfoJWT = null;
    if (!this.getFromSessionStorage('A_DATA')) {
      profileInfoJWT = jwtDecode<any>(token.access_token);
      const username = profileInfoJWT?.preferred_username;
      const adoptedProfileInfo = {
        id: profileInfoJWT?.provider_response.user_info?.id,
        username: profileInfoJWT?.preferred_username,
        firstname: profileInfoJWT?.provider_response.user_info?.firstname,
        lastname: profileInfoJWT?.provider_response.user_info?.lastname,
        middlename: profileInfoJWT?.provider_response.user_info?.middlename,
        iin: profileInfoJWT?.provider_response.user_info?.iin,
      };
      this.setToSessionStorage('A_DATA', { phoneNumber: username });
      this.setToSessionStorage('P', adoptedProfileInfo);
    }
    if (!this.getFromSessionStorage('S_COMPANY')) {
      const companyInfoJWT = profileInfoJWT?.provider_response.user_info.organization;
      const adoptedSelectedCompanyInfo = {
      bin: companyInfoJWT?.idn,
      custname: companyInfoJWT?.customerName,
      division: companyInfoJWT?.division || '',
      pcustomer: companyInfoJWT?.customerId,
      client_code: companyInfoJWT?.cliCode,
      client_type: companyInfoJWT?.clientType,
    };
      this.setToSessionStorage('S_COMPANY', adoptedSelectedCompanyInfo);
    }
  }

  setToLocalStorage(key: string, value: any): void {
    localStorage.setItem(key, value);
  }

  getFromLocalStorage(key: string): any {
    const item = localStorage.getItem(key) || undefined;

    try {
      return (JSON.parse(JSON.parse(item)));
    } catch (e) {
       return item;
    }
  }
}
